<template>
  <div id="contenedor-expedientes-catalogo-documentos-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-on:nuevoExpedienteCatalogoDocumento="registrarNuevoExpedienteCatalogoDocumento"
            v-on:buscar="buscar">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoExpedienteCatalogoDocumentos="getExpedientes"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana para crear expediente catalogo documento -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoExpedienteCatalogoDocumento"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <registrar-nuevo-expediente-catalogo-documento
        v-if="mostrarVentanaRegistrarNuevoExpedienteCatalogoDocumento"
        v-on:cerrar="cerrarVentana">
      </registrar-nuevo-expediente-catalogo-documento>
    </v-dialog>
    <!-- Ventana para actualizar expediente catalogo documento -->
    <v-dialog
    v-if="esteExpedienteCatalogoDocumento"
      v-model="mostrarVentanaEditarExpedienteCatalogoDocumento"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <editar-expediente-catalogo-documento
      :expedienteEditar="esteExpedienteCatalogoDocumento"
        v-on:cerrar="cerrarVentana">
      </editar-expediente-catalogo-documento>
    </v-dialog>
    <!-- Ventana para eliminar expediente catalogo documento -->
    <v-dialog
    v-if="esteExpedienteCatalogoDocumento"
      v-model="mostrarVentanaEliminarExpedienteCatalogoDocumento"
      width="450">
      <eliminar-expediente-catalogo-documento
      :expedienteEliminar="esteExpedienteCatalogoDocumento"
        v-on:cerrar="cerrarVentana">
      </eliminar-expediente-catalogo-documento>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_EXPEDIENTE from '@/graphql/querys/administracion/catalogos/expedientes/catalogoExpediente.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoExpedienteCatalogoDocumento from '@/components/administracion/configuracion/catalogos/expedientes/Nuevo.vue';
import EditarExpedienteCatalogoDocumento from '@/components/administracion/configuracion/catalogos/expedientes/Editar.vue';
import EliminarExpedienteCatalogoDocumento from '@/components/administracion/configuracion/catalogos/expedientes/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ExpedientesCatalogoDocumentosDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoExpedienteCatalogoDocumento,
    EditarExpedienteCatalogoDocumento,
    EliminarExpedienteCatalogoDocumento,
    ToolBar,
    Listado,
  },
  data() {
    return {
      buscarTexto: '',
      mostrarVentanaRegistrarNuevoExpedienteCatalogoDocumento: false,
      mostrarVentanaEditarExpedienteCatalogoDocumento: false,
      mostrarVentanaEliminarExpedienteCatalogoDocumento: false,
      esteExpedienteCatalogoDocumento: null,
    };
  },
  apollo: {
    catalogoExpediente: {
      query: CATALOGO_EXPEDIENTE,
    },
  },
  mounted() {
    eventBus.$on('editar-expediente-catalogo-documento', (expedienteCatalogoDocumento) => {
      this.esteExpedienteCatalogoDocumento = expedienteCatalogoDocumento;
      this.mostrarVentanaEditarExpedienteCatalogoDocumento = true;
    });
    eventBus.$on('eliminar-expediente-catalogo-documento', (expedienteCatalogoDocumento) => {
      this.esteExpedienteCatalogoDocumento = expedienteCatalogoDocumento;
      this.mostrarVentanaEliminarExpedienteCatalogoDocumento = true;
    });
  },
  methods: {
    buscar(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
    registrarNuevoExpedienteCatalogoDocumento() {
      this.mostrarVentanaRegistrarNuevoExpedienteCatalogoDocumento = true;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevoExpedienteCatalogoDocumento = false;
      this.mostrarVentanaEditarExpedienteCatalogoDocumento = false;
      this.mostrarVentanaEliminarExpedienteCatalogoDocumento = false;
      this.esteExpedienteCatalogoDocumento = null;
    },
  },
  computed: {
    getExpedientes() {
      if (!this.catalogoExpediente) return [];
      return this.catalogoExpediente
        .filter((expedienteDocumento) => {
          if (!this.buscarTexto) return expedienteDocumento;
          const expt = new RegExp(this.buscarTexto, 'gi');

          const descripcion = this.$normalizacionTexto(expedienteDocumento.descripcion);
          const modulo = this.$normalizacionTexto(expedienteDocumento.modulo);
          const normatividad = this.$normalizacionTexto(expedienteDocumento.normatividad);

          return (
            expt.test(descripcion)
            || expt.test(modulo)
            || expt.test(normatividad)
            || expt.test(expedienteDocumento.descripcion)
            || expt.test(expedienteDocumento.modulo)
            || expt.test(expedienteDocumento.normatividad)
          );
        })
        .sort((a, b) => (a.etapa - b.etapa) || (a.orden - b.orden));
    },
  },
};
</script>

<style lang="scss">

</style>
